"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Module = exports.graphURLBase = exports.moduleURLBase = void 0;
const lincd_1 = require("../ontologies/lincd");
const package_1 = require("../package");
const rdf_1 = require("lincd/lib/ontologies/rdf");
const Component_1 = require("./Component");
const Module_1 = require("lincd-npm/lib/shapes/Module");
exports.moduleURLBase = 'https://data.lincd.org/module/';
exports.graphURLBase = 'https://data.lincd.org/graph/';
let Module = class Module extends Module_1.Module {
    getComponents() {
        return Component_1.Component.getSetOf(this.getExports().filter((node) => node.getOne(rdf_1.rdf.type) == lincd_1.lincd.Component));
    }
    getExports() {
        return this.getAllInverse(lincd_1.lincd.module);
    }
    static getLincdModuleURI(packageName, versionNumber) {
        // return moduleURLBase + packageName + '/' + versionNumber;
        return exports.moduleURLBase + packageName;
    }
    static getLincdModuleGraphURI(module) {
        return exports.graphURLBase + module.packageName + '/' + module.version;
    }
};
Module.targetClass = lincd_1.lincd.Module;
Module = __decorate([
    package_1.linkedShape
    /**
     * A LINCD Module. Contains ShapeClasses, Components and OntologyFiles
     * Extends NPMModule.
     * A LINCD module can have dependencies to other LINCD modules as well as regular NPM modules
     */
], Module);
exports.Module = Module;
//# sourceMappingURL=Module.js.map